import React from 'react';
import ModalFrame from '../../ModalFrame';
import CsvInfo from './CsvInfo';

class CsvModalController extends React.Component {
  constructor(props) {
    super(props);
    this.hideModal = this.hideModal.bind(this);

  }


  hideModal() {
    const {setModalInfo} = this.props;
    setModalInfo({});
  }

  render() {
    const {modalInfo, cancelHandler} = this.props;
    return (
      <div className="csv-modal">
        {modalInfo.name === 'csvInfo' ?
          <ModalFrame
            title={modalInfo.title}
            desktopWidth="70%"
            headerCloseButtonHandler={this.hideModal}
            hasHeader={true}>
            <CsvInfo
              modalInfo={modalInfo}
              hideModal={this.hideModal}
              cancelHandler={cancelHandler}
            />
          </ModalFrame> : null}
      </div>
    )
  }
}

export default CsvModalController;
